<template>
  <stat :title="$t('wallet.title')" :loading="loading">
    <template v-if="currentWallet">
      <price
        v-if="currentWallet"
        :value="currentWallet.amount"
        :currency="currentWallet.currency">
      </price>
      <template slot="actions">
        <v-dialog
          v-if="currentWallet.amount"
          v-model="modal" lazy>
          <v-btn
            slot="activator"
            primary flat light>
            {{ $t('wallet.transfer') }}
          </v-btn>
          <transfer
            :maxAmount="currentWallet.amount"
            :currency="currentWallet.currency"
            @transferDone="modal = false">
          </transfer>
        </v-dialog>
      </template>
    </template>
    <span v-else>-</span>
  </stat>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { Price } from '@/components/formatters'
  import Stat from '@/components/Stat.vue'
  import Transfer from '@/components/Transfer.vue'
  export default {
    components: {
      Stat,
      Price,
      Transfer
    },
    data () {
      return {
        modal: false
      }
    },
    computed: {
      ...mapGetters({
        wallet: 'skiliko/wallets/wallet',
        loading: 'skiliko/wallets/isLoading'
      }),
      currentWallet () {
        return (this.wallet.availables || [])[0]
      }
    },
    methods: mapActions({
      fetch: 'skiliko/wallets/fetch'
    }),
    mounted () {
      this.fetch()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Wallet.vue